import { Component } from '@angular/core';
import { LastplayersState } from '../../@core/ngrx/lastplayers/lastplayers.state';
import { Store, select } from '@ngrx/store';
import * as fromLastplayersAction from 'src/app/@core/ngrx/lastplayers/lastplayers.actions';
import { selectAllLastplayersItemsPresent } from '../../@core/ngrx/lastplayers/lastplayers.selectors';
import { Observable, of } from 'rxjs';
import { RankListResponseWrapper } from '../../api/models';
import { isLoading } from 'src/app/@core/ngrx/runningaction/running-action.selectors';
import { ActivatedRoute } from '@angular/router';
import { ThemeService } from 'src/app/@core/services/theme.service';

@Component({
  selector: 'app-lastplayers-pages',
  templateUrl: './lastplayers-pages.component.html',
  styleUrls: ['./lastplayers-pages.component.scss'],
})
export class LastplayersPagesComponent {
  lastPlayers$: Observable<RankListResponseWrapper[]> = new Observable();
  room?: string;
  branch?: string;
  loading$: Observable<boolean> = of(false);
  theme: string = '';

  constructor(
    private store: Store<LastplayersState>,
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
  ) {
    this.lastPlayers$ = this.store.pipe(
      select(selectAllLastplayersItemsPresent),
    );
  }

  ngOnInit() {
    this.loading$ = this.store.pipe(
      select(isLoading([fromLastplayersAction.loadMany])),
    );

    this.room = this.activatedRoute.snapshot.url[2].path;
    this.branch = this.activatedRoute.snapshot.url[1].path;

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['color']) {
        this.theme = params['color'];
      } else {
        this.theme = 'light';
      }
      this.themeService.setTheme(this.theme!);
    });

    this.theme === 'dark'
      ? document.body.classList.add('dark-theme')
      : document.body.classList.add('light-theme');

    this.store.dispatch(
      fromLastplayersAction.loadMany({
        room: this.room,
        nameSpace: this.branch,
      }),
    );
  }
}
